import style from './style'

export const cursor = style({prop: 'cursor'})
